var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"webdesc webdesc_hui"},[_vm._v("若您对网站有任何意见或者建议，请发邮件至 service@holylightbbs.com Copyright © 2025 圣光检索")])
}
var staticRenderFns = []

export { render, staticRenderFns }